export const languages = {
  en: { name: 'English', nativeName: 'English' },
  hi: { name: 'Hindi', nativeName: 'हिन्दी' },
  bn: { name: 'Bengali', nativeName: 'বাংলা' },
  te: { name: 'Telugu', nativeName: 'తెలుగు' },
  mr: { name: 'Marathi', nativeName: 'मराठी' },
  ta: { name: 'Tamil', nativeName: 'தமிழ்' },
  kn: { name: 'Kannada', nativeName: 'ಕನ್ನಡ' },
  ml: { name: 'Malayalam', nativeName: 'മലയാളം' },
};

const en = {
  'app.tagline': 'Income protection for delivery partners',
  'common.loading': 'Loading...',
  'common.logout': 'Logout',
  'nav.dashboard': 'Home',
  'nav.policy': 'Policy',
  'nav.claims': 'Claims',
  'nav.admin': 'Admin',
  'dash.greeting.morning': 'Good morning',
  'dash.greeting.afternoon': 'Good afternoon',
  'dash.greeting.evening': 'Good evening',
  'dash.weeklyCoverage': 'Weekly Coverage',
  'dash.noActivePolicy': 'No active policy',
  'dash.activatePolicy': 'Activate Weekly Policy →',
  'dash.weeklyPremium': 'Weekly Premium',
  'dash.recentClaims': 'Recent Claims',
  'dash.claimsFree': 'Claims-Free',
  'dash.liveMonitor': 'Live Disruption Monitor',
  'dash.noDisruption': 'No live disruption data available right now.',
  'dash.simulateTitle': 'Simulate Disruption',
  'dash.simulateDesc': 'Run the full automated claim pipeline with the current backend logic.',
  'dash.simulateBtn': 'Simulate Rain Claim',
  'dash.processing': 'Processing...',
  'dash.noClaims': 'No claims yet.',
  'dash.viewAll': 'View all →',
  'dash.workSchedule': 'Work Schedule',
  'dash.workingHours': 'Working Hours',
  'dash.partTime': 'Part-time (4-6 hrs/day)',
  'dash.fullTime': 'Full-time (8-12 hrs/day)',
  'dash.extended': 'Extended (12-16 hrs/day)',
  'dash.shiftStart': 'Shift Start',
  'dash.shiftEnd': 'Shift End',
  'dash.workingDays': 'Working Days',
  'dash.saveSchedule': 'Save Schedule',
  'dash.saving': 'Saving...',
  'policy.title': 'Insurance Policy',
  'policy.subtitle': 'Weekly income protection that renews every Monday',
  'policy.active': 'ACTIVE',
  'policy.protected': 'protected',
  'policy.expires': 'Expires',
  'policy.cancel': 'Cancel Policy',
  'policy.chooseTier': 'Choose Coverage Tier',
  'policy.premiumBreakdown': 'Premium Breakdown',
  'policy.perWeek': 'per week · UPI AutoPay every Monday',
  'policy.maxPayout': 'Max payout',
  'policy.baseRate': 'Base rate',
  'policy.zoneRisk': 'Zone risk factor',
  'policy.seasonMul': 'Season multiplier',
  'policy.claimsFreeDisc': 'Claims-free discount',
  'policy.surgeLoading': 'Surge loading',
  'policy.tierMul': 'Tier multiplier',
  'policy.weeklyPremium': 'Weekly Premium',
  'policy.activate': 'Activate',
  'policy.activating': 'Activating...',
  'policy.history': 'Policy History',
  'policy.popular': 'POPULAR',
  'tier.basic': 'Basic',
  'tier.standard': 'Standard',
  'tier.premium': 'Premium',
  'tier.basic.desc': 'Occasional workers',
  'tier.standard.desc': 'Recommended',
  'tier.premium.desc': 'Maximum protection',
  'claims.title': 'Claims',
  'claims.subtitle': 'Automated income protection payouts',
  'claims.simulator': 'Disruption Simulator',
  'claims.fireTrigger': 'Fire Trigger →',
  'claims.processingPipeline': 'Processing pipeline...',
  'claims.processed': 'Claim Processed',
  'claims.predictedLoss': 'Predicted loss',
  'claims.actualEarned': 'Actual earned',
  'claims.netLoss': 'Net loss',
  'claims.coverage': 'Coverage',
  'claims.payout': 'Payout',
  'claims.fraudScore': 'Fraud score',
  'claims.ppcs': 'PPCS',
  'claims.decision': 'Decision',
  'claims.history': 'Claims History',
  'claims.noClaims': 'No claims yet. Simulate a disruption above to see the pipeline in action.',
  'onboard.getStarted': 'Get Started',
  'onboard.enterPhone': 'Enter your phone number to begin with OTP verification.',
  'onboard.mobile': 'Mobile Number',
  'onboard.sendOtp': 'Send OTP →',
  'onboard.sending': 'Sending...',
  'onboard.terms': 'By continuing, you agree to our Terms and Conditions.',
  'onboard.verifyOtp': 'Verify OTP',
  'onboard.sentTo': 'Sent to +91',
  'onboard.otpLabel': '6-digit OTP',
  'onboard.verifyBtn': 'Verify OTP →',
  'onboard.verifying': 'Verifying...',
  'onboard.backPhone': 'Back to phone number',
  'onboard.profile': 'Your Profile',
  'onboard.profileDesc': 'Tell us about yourself and your delivery work.',
  'onboard.fullName': 'Full Name',
  'onboard.aadhaar': 'Aadhaar Last 4 Digits',
  'onboard.upiId': 'UPI ID',
  'onboard.platforms': 'Platforms',
  'onboard.continue': 'Continue →',
  'onboard.workArea': 'Your Work Area',
  'onboard.workAreaDesc': 'Used to calculate premium, risk zone, and payout windows.',
  'onboard.city': 'City',
  'onboard.selectCity': 'Select city',
  'onboard.zone': 'Zone',
  'onboard.selectZone': 'Select zone',
  'onboard.weeklyIncome': 'Weekly Income',
  'onboard.activateKavach': 'Activate KAVACH →',
  'onboard.creatingAccount': 'Creating account...',
  'onboard.back': 'Back',
  'onboard.fillRequired': 'Please fill all required fields',
  'onboard.about': 'About',
  'onboard.howItWorks': 'How It Works',
  'onboard.faqs': 'FAQs',
  'onboard.whyKavach': 'Why Delivery Partners Choose KAVACH',
  'onboard.builtFor': 'Built specifically for India\'s gig economy workers',
  'onboard.howTitle': 'How KAVACH Works',
  'onboard.faqTitle': 'Frequently Asked Questions',
  'onboard.faqSubtitle': 'Everything you need to know about KAVACH',
  'hero.badge': "INDIA'S FIRST AI INCOME SHIELD",
  'hero.title1': 'The Policy That',
  'hero.title2': 'Rides With You',
  'hero.desc': "AI-powered income protection for India's gig delivery partners. Get covered against rain, floods, AQI, and disruptions with server-verified claims and fast payouts.",
  'hero.stat1.value': '10,000+',
  'hero.stat1.label': 'Delivery Partners',
  'hero.stat2.label': 'Claims Settled',
  'hero.stat3.value': '<60s',
  'hero.stat3.label': 'Avg. Processing',
  'hero.stat4.value': '16 Cities',
  'hero.stat4.label': 'Coverage Network',
  'hero.testimonial': "'Finally, an income shield built for gig workers.'",
  'hero.testimonialSub': 'Server-verified triggers, ML-backed loss prediction, direct payout.',
  'feature.weather.title': 'Weather Protection',
  'feature.weather.desc': 'Auto-payouts when rain or floods disrupt your deliveries',
  'feature.instant.title': 'Instant Claims',
  'feature.instant.desc': 'AI verifies and processes claims in under a minute',
  'feature.upi.title': 'UPI Payouts',
  'feature.upi.desc': 'Money directly to your payout rail with no paperwork',
  'feature.weekly.title': 'Weekly Plans',
  'feature.weekly.desc': 'Flexible weekly coverage tailored for delivery work',
  'step.register': 'Register',
  'step.register.desc': 'Sign up with your phone number and delivery platform details',
  'step.plan': 'Choose a Plan',
  'step.plan.desc': 'Pick Basic, Standard, or Premium weekly coverage tier',
  'step.protected': 'Stay Protected',
  'step.protected.desc': 'AI monitors weather, AQI & disruptions in your delivery zone',
  'step.paid': 'Get Paid',
  'step.paid.desc': 'Automatic payout to your UPI when disruption is detected',
  'faq.q1': 'What is KAVACH?',
  'faq.a1': 'KAVACH is an AI-powered income protection platform for gig delivery partners. It provides weekly coverage against weather disruptions, floods, AQI spikes, curfews, and platform outages.',
  'faq.q2': 'How does the payout work?',
  'faq.a2': 'When a verified disruption is detected in your delivery zone during your shift hours, KAVACH automatically calculates your income loss using ML models and processes a payout directly to your UPI ID — often within 60 seconds.',
  'faq.q3': 'What coverage tiers are available?',
  'faq.a3': 'KAVACH offers three tiers — Basic (50% coverage for occasional workers), Standard (70% coverage, recommended), and Premium (85% coverage for maximum protection). Premiums adjust based on your city, zone risk, and claims-free history.',
  'faq.q4': 'How are claims verified?',
  'faq.a4': 'Claims are verified using server-side data from government weather APIs (IMD), air quality servers (CPCB), and platform status checks. No manual uploads or forms are needed — everything is automated and transparent.',
  'faq.q5': 'Can I cancel my policy?',
  'faq.a5': 'Yes, you can cancel your active weekly policy at any time from the Policy tab. Coverage is weekly, so there are no long-term lock-ins. You can reactivate any time.',
  'faq.q6': 'Which cities are supported?',
  'faq.a6': 'KAVACH currently operates across 16 major Indian cities including Mumbai, Delhi, Bengaluru, Chennai, Hyderabad, Pune, Kolkata, and more. We are rapidly expanding to cover additional cities.',
  'footer.tagline': 'THE POLICY THAT RIDES WITH YOU',
  'footer.privacy': 'Privacy Policy',
  'footer.terms': 'Terms of Service',
  'footer.contact': 'Contact Us',
  'footer.copyright': '© 2026 KAVACH Insurance. All rights reserved. | Powered by AI for India\'s delivery heroes ⚡',
  'onboard.shiftStart': 'Shift Start',
  'onboard.shiftEnd': 'Shift End',
  'onboard.workingDays': 'Working Days',
  'onboard.workingHours': 'Working Hours',
  'onboard.partTime': 'Part-time (4-6 hrs/day)',
  'onboard.fullTime': 'Full-time (8-12 hrs/day)',
  'onboard.extended': 'Extended (12-16 hrs/day)',
  'onboard.devOtp': 'Dev OTP',
};

const hi = {
  ...en,
  'app.tagline': 'डिलीवरी पार्टनर्स के लिए आय सुरक्षा',
  'common.loading': 'लोड हो रहा है...',
  'common.logout': 'लॉग आउट',
  'nav.dashboard': 'होम',
  'nav.policy': 'पॉलिसी',
  'nav.claims': 'क्लेम',
  'nav.admin': 'एडमिन',
  'dash.greeting.morning': 'सुप्रभात',
  'dash.greeting.afternoon': 'नमस्कार',
  'dash.greeting.evening': 'शुभ संध्या',
  'dash.weeklyCoverage': 'साप्ताहिक कवरेज',
  'dash.noActivePolicy': 'कोई सक्रिय पॉलिसी नहीं',
  'dash.activatePolicy': 'साप्ताहिक पॉलिसी सक्रिय करें →',
  'dash.weeklyPremium': 'साप्ताहिक प्रीमियम',
  'dash.recentClaims': 'हाल के क्लेम',
  'dash.claimsFree': 'क्लेम-मुक्त',
  'dash.liveMonitor': 'लाइव व्यवधान मॉनिटर',
  'dash.noDisruption': 'अभी कोई लाइव व्यवधान डेटा उपलब्ध नहीं।',
  'dash.simulateTitle': 'व्यवधान सिमुलेट करें',
  'dash.simulateDesc': 'मौजूदा बैकएंड लॉजिक के साथ पूर्ण ऑटोमेटेड क्लेम पाइपलाइन चलाएं।',
  'dash.simulateBtn': 'बारिश क्लेम सिमुलेट करें',
  'dash.processing': 'प्रोसेसिंग...',
  'dash.noClaims': 'अभी तक कोई क्लेम नहीं।',
  'dash.viewAll': 'सभी देखें →',
  'dash.workSchedule': 'कार्य शेड्यूल',
  'dash.workingHours': 'कार्य घंटे',
  'dash.partTime': 'पार्ट-टाइम (4-6 घंटे/दिन)',
  'dash.fullTime': 'फुल-टाइम (8-12 घंटे/दिन)',
  'dash.extended': 'एक्सटेंडेड (12-16 घंटे/दिन)',
  'dash.shiftStart': 'शिफ्ट शुरू',
  'dash.shiftEnd': 'शिफ्ट समाप्त',
  'dash.workingDays': 'कार्य दिवस',
  'dash.saveSchedule': 'शेड्यूल सेव करें',
  'dash.saving': 'सेव हो रहा है...',
  'policy.title': 'बीमा पॉलिसी',
  'policy.subtitle': 'साप्ताहिक आय सुरक्षा जो हर सोमवार नवीनीकृत होती है',
  'policy.protected': 'सुरक्षित',
  'policy.expires': 'समाप्ति',
  'policy.cancel': 'पॉलिसी रद्द करें',
  'policy.chooseTier': 'कवरेज टियर चुनें',
  'policy.premiumBreakdown': 'प्रीमियम विवरण',
  'policy.perWeek': 'प्रति सप्ताह · UPI ऑटोपे हर सोमवार',
  'policy.maxPayout': 'अधिकतम भुगतान',
  'policy.baseRate': 'आधार दर',
  'policy.zoneRisk': 'ज़ोन जोखिम कारक',
  'policy.seasonMul': 'सीज़न गुणक',
  'policy.claimsFreeDisc': 'क्लेम-मुक्त छूट',
  'policy.surgeLoading': 'सर्ज लोडिंग',
  'policy.tierMul': 'टियर गुणक',
  'policy.weeklyPremium': 'साप्ताहिक प्रीमियम',
  'policy.activate': 'सक्रिय करें',
  'policy.activating': 'सक्रिय हो रहा है...',
  'policy.history': 'पॉलिसी इतिहास',
  'tier.basic': 'बेसिक',
  'tier.standard': 'स्टैंडर्ड',
  'tier.premium': 'प्रीमियम',
  'tier.basic.desc': 'कभी-कभार काम करने वाले',
  'tier.standard.desc': 'अनुशंसित',
  'tier.premium.desc': 'अधिकतम सुरक्षा',
  'claims.title': 'क्लेम',
  'claims.subtitle': 'ऑटोमेटेड आय सुरक्षा भुगतान',
  'claims.simulator': 'व्यवधान सिमुलेटर',
  'claims.fireTrigger': 'ट्रिगर दबाएं →',
  'claims.processingPipeline': 'पाइपलाइन प्रोसेसिंग...',
  'claims.processed': 'क्लेम प्रोसेस हुआ',
  'claims.history': 'क्लेम इतिहास',
  'claims.noClaims': 'अभी तक कोई क्लेम नहीं। पाइपलाइन देखने के लिए ऊपर व्यवधान सिमुलेट करें।',
  'onboard.getStarted': 'शुरू करें',
  'onboard.enterPhone': 'OTP सत्यापन शुरू करने के लिए अपना फोन नंबर दर्ज करें।',
  'onboard.mobile': 'मोबाइल नंबर',
  'onboard.sendOtp': 'OTP भेजें →',
  'onboard.sending': 'भेज रहा है...',
  'onboard.terms': 'जारी रखकर, आप हमारी शर्तों से सहमत होते हैं।',
  'onboard.verifyOtp': 'OTP सत्यापित करें',
  'onboard.sentTo': '+91 पर भेजा गया',
  'onboard.otpLabel': '6-अंक OTP',
  'onboard.verifyBtn': 'OTP सत्यापित करें →',
  'onboard.verifying': 'सत्यापित हो रहा है...',
  'onboard.backPhone': 'फोन नंबर पर वापस',
  'onboard.profile': 'आपकी प्रोफ़ाइल',
  'onboard.profileDesc': 'अपने बारे में और अपने डिलीवरी काम के बारे में बताएं।',
  'onboard.fullName': 'पूरा नाम',
  'onboard.aadhaar': 'आधार के अंतिम 4 अंक',
  'onboard.upiId': 'UPI आईडी',
  'onboard.platforms': 'प्लेटफॉर्म',
  'onboard.continue': 'जारी रखें →',
  'onboard.workArea': 'आपका कार्य क्षेत्र',
  'onboard.workAreaDesc': 'प्रीमियम, जोखिम ज़ोन, और भुगतान विंडो की गणना के लिए उपयोग किया जाता है।',
  'onboard.city': 'शहर',
  'onboard.selectCity': 'शहर चुनें',
  'onboard.zone': 'ज़ोन',
  'onboard.selectZone': 'ज़ोन चुनें',
  'onboard.weeklyIncome': 'साप्ताहिक आय',
  'onboard.activateKavach': 'KAVACH सक्रिय करें →',
  'onboard.creatingAccount': 'खाता बन रहा है...',
  'onboard.back': 'वापस',
  'onboard.fillRequired': 'कृपया सभी आवश्यक फ़ील्ड भरें',
  'onboard.whyKavach': 'डिलीवरी पार्टनर KAVACH क्यों चुनते हैं',
  'onboard.builtFor': 'भारत के गिग इकोनॉमी वर्कर्स के लिए विशेष रूप से निर्मित',
  'onboard.howTitle': 'KAVACH कैसे काम करता है',
  'onboard.faqTitle': 'अक्सर पूछे जाने वाले प्रश्न',
  'onboard.faqSubtitle': 'KAVACH के बारे में सब कुछ जानें',
  'hero.badge': 'भारत की पहली AI आय ढाल',
  'hero.title1': 'वो पॉलिसी जो',
  'hero.title2': 'आपके साथ चले',
  'hero.desc': 'भारत के गिग डिलीवरी पार्टनर्स के लिए AI-संचालित आय सुरक्षा। बारिश, बाढ़, AQI और व्यवधानों से सर्वर-सत्यापित क्लेम और तेज़ भुगतान के साथ कवर हों।',
  'hero.stat1.value': '10,000+',
  'hero.stat1.label': 'डिलीवरी पार्टनर',
  'hero.stat2.label': 'क्लेम सेटल',
  'hero.stat3.value': '<60s',
  'hero.stat3.label': 'औसत प्रोसेसिंग',
  'hero.stat4.value': '16 शहर',
  'hero.stat4.label': 'कवरेज नेटवर्क',
  'hero.testimonial': "'आखिरकार, गिग वर्कर्स के लिए बनी एक आय ढाल।'",
  'hero.testimonialSub': 'सर्वर-सत्यापित ट्रिगर, ML-आधारित हानि भविष्यवाणी, सीधा भुगतान।',
  'feature.weather.title': 'मौसम सुरक्षा',
  'feature.weather.desc': 'बारिश या बाढ़ से डिलीवरी बाधित होने पर ऑटो-भुगतान',
  'feature.instant.title': 'तत्काल क्लेम',
  'feature.instant.desc': 'AI एक मिनट से कम में क्लेम सत्यापित और प्रोसेस करता है',
  'feature.upi.title': 'UPI भुगतान',
  'feature.upi.desc': 'बिना कागज़ात के सीधे आपके UPI में पैसे',
  'feature.weekly.title': 'साप्ताहिक प्लान',
  'feature.weekly.desc': 'डिलीवरी काम के लिए लचीला साप्ताहिक कवरेज',
  'step.register': 'रजिस्टर करें',
  'step.register.desc': 'अपने फोन नंबर और डिलीवरी प्लेटफॉर्म विवरण से साइन अप करें',
  'step.plan': 'प्लान चुनें',
  'step.plan.desc': 'बेसिक, स्टैंडर्ड, या प्रीमियम साप्ताहिक कवरेज टियर चुनें',
  'step.protected': 'सुरक्षित रहें',
  'step.protected.desc': 'AI आपके डिलीवरी ज़ोन में मौसम, AQI और व्यवधानों की निगरानी करता है',
  'step.paid': 'भुगतान पाएं',
  'step.paid.desc': 'व्यवधान पाए जाने पर आपके UPI में स्वचालित भुगतान',
  'faq.q1': 'KAVACH क्या है?',
  'faq.a1': 'KAVACH गिग डिलीवरी पार्टनर्स के लिए AI-संचालित आय सुरक्षा प्लेटफॉर्म है। यह मौसम व्यवधान, बाढ़, AQI स्पाइक, कर्फ्यू और प्लेटफॉर्म आउटेज के खिलाफ साप्ताहिक कवरेज प्रदान करता है।',
  'faq.q2': 'भुगतान कैसे काम करता है?',
  'faq.a2': 'जब आपके डिलीवरी ज़ोन में शिफ्ट के दौरान सत्यापित व्यवधान पाया जाता है, KAVACH ML मॉडल से आय हानि की गणना करता है और सीधे UPI में भुगतान करता है — अक्सर 60 सेकंड में।',
  'faq.q3': 'कौन से कवरेज टियर उपलब्ध हैं?',
  'faq.a3': 'KAVACH तीन टियर प्रदान करता है — बेसिक (50% कवरेज), स्टैंडर्ड (70% कवरेज, अनुशंसित), और प्रीमियम (85% कवरेज)। प्रीमियम आपके शहर, ज़ोन जोखिम और क्लेम-मुक्त इतिहास के आधार पर समायोजित होता है।',
  'faq.q4': 'क्लेम कैसे सत्यापित होते हैं?',
  'faq.a4': 'क्लेम सरकारी मौसम API (IMD), वायु गुणवत्ता सर्वर (CPCB) और प्लेटफॉर्म स्थिति जांच से सर्वर-साइड डेटा का उपयोग करके सत्यापित किए जाते हैं। कोई मैन्युअल अपलोड नहीं — सब कुछ स्वचालित है।',
  'faq.q5': 'क्या मैं अपनी पॉलिसी रद्द कर सकता हूं?',
  'faq.a5': 'हां, आप किसी भी समय पॉलिसी टैब से अपनी सक्रिय साप्ताहिक पॉलिसी रद्द कर सकते हैं। कवरेज साप्ताहिक है, कोई लंबी अवधि की बाध्यता नहीं।',
  'faq.q6': 'कौन से शहर समर्थित हैं?',
  'faq.a6': 'KAVACH वर्तमान में मुंबई, दिल्ली, बेंगलुरु, चेन्नई, हैदराबाद, पुणे, कोलकाता सहित 16 प्रमुख भारतीय शहरों में संचालित है।',
  'footer.tagline': 'वो पॉलिसी जो आपके साथ चले',
  'footer.privacy': 'गोपनीयता नीति',
  'footer.terms': 'सेवा की शर्तें',
  'footer.contact': 'संपर्क करें',
  'footer.copyright': '© 2026 KAVACH बीमा। सर्वाधिकार सुरक्षित। | भारत के डिलीवरी हीरोज़ के लिए AI-संचालित ⚡',
  'onboard.shiftStart': 'शिफ्ट शुरू',
  'onboard.shiftEnd': 'शिफ्ट समाप्त',
  'onboard.workingDays': 'कार्य दिवस',
  'onboard.workingHours': 'कार्य घंटे',
  'onboard.partTime': 'पार्ट-टाइम (4-6 घंटे/दिन)',
  'onboard.fullTime': 'फुल-टाइम (8-12 घंटे/दिन)',
  'onboard.extended': 'एक्सटेंडेड (12-16 घंटे/दिन)',
  'onboard.devOtp': 'डेव OTP',
};

const bn = {
  ...en,
  'app.tagline': 'ডেলিভারি পার্টনারদের জন্য আয় সুরক্ষা',
  'common.loading': 'লোড হচ্ছে...',
  'common.logout': 'লগ আউট',
  'nav.dashboard': 'হোম',
  'nav.policy': 'পলিসি',
  'nav.claims': 'দাবি',
  'nav.admin': 'অ্যাডমিন',
  'dash.greeting.morning': 'সুপ্রভাত',
  'dash.greeting.afternoon': 'শুভ অপরাহ্ন',
  'dash.greeting.evening': 'শুভ সন্ধ্যা',
  'dash.weeklyCoverage': 'সাপ্তাহিক কভারেজ',
  'dash.noActivePolicy': 'কোনো সক্রিয় পলিসি নেই',
  'dash.activatePolicy': 'সাপ্তাহিক পলিসি সক্রিয় করুন →',
  'dash.weeklyPremium': 'সাপ্তাহিক প্রিমিয়াম',
  'dash.recentClaims': 'সাম্প্রতিক দাবি',
  'dash.claimsFree': 'দাবি-মুক্ত',
  'dash.liveMonitor': 'লাইভ ব্যাঘাত মনিটর',
  'dash.noDisruption': 'এই মুহূর্তে কোনো লাইভ ব্যাঘাত ডেটা উপলব্ধ নেই।',
  'dash.simulateTitle': 'ব্যাঘাত সিমুলেট করুন',
  'dash.simulateDesc': 'বর্তমান ব্যাকএন্ড লজিকের সাথে সম্পূর্ণ স্বয়ংক্রিয় দাবি পাইপলাইন চালান।',
  'dash.simulateBtn': 'বৃষ্টির দাবি সিমুলেট করুন',
  'dash.processing': 'প্রক্রিয়াকরণ হচ্ছে...',
  'dash.noClaims': 'এখনও কোনো দাবি নেই।',
  'dash.viewAll': 'সব দেখুন →',
  'dash.workSchedule': 'কাজের সময়সূচী',
  'dash.workingHours': 'কাজের সময়',
  'dash.partTime': 'খণ্ডকালীন (৪-৬ ঘণ্টা/দিন)',
  'dash.fullTime': 'পূর্ণকালীন (৮-১২ ঘণ্টা/দিন)',
  'dash.extended': 'বর্ধিত (১২-১৬ ঘণ্টা/দিন)',
  'dash.shiftStart': 'শিফট শুরু',
  'dash.shiftEnd': 'শিফট শেষ',
  'dash.workingDays': 'কাজের দিন',
  'dash.saveSchedule': 'সময়সূচী সংরক্ষণ করুন',
  'dash.saving': 'সংরক্ষণ করা হচ্ছে...',
  'policy.title': 'বীমা পলিসি',
  'policy.subtitle': 'প্রতি সোমবার নবায়নযোগ্য সাপ্তাহিক আয় সুরক্ষা',
  'policy.active': 'সক্রিয়',
  'policy.protected': 'সুরক্ষিত',
  'policy.expires': 'মেয়াদ উত্তীর্ণ',
  'policy.cancel': 'পলিসি বাতিল করুন',
  'policy.chooseTier': 'কভারেজ টিয়ার বেছে নিন',
  'policy.premiumBreakdown': 'প্রিমিয়াম বিবরণ',
  'policy.perWeek': 'প্রতি সপ্তাহ · ইউপিআই অটো-পে প্রতি সোমবার',
  'policy.maxPayout': 'সর্বোচ্চ পেআউট',
  'policy.baseRate': 'বেস রেট',
  'policy.zoneRisk': 'জোন ঝুঁকি ফ্যাক্টর',
  'policy.seasonMul': 'সিজন গুণক',
  'policy.claimsFreeDisc': 'দাবি-মুক্ত ডিসকাউন্ট',
  'policy.surgeLoading': 'সার্জ লোডিং',
  'policy.tierMul': 'টিয়ার গুণক',
  'policy.weeklyPremium': 'সাপ্তাহিক প্রিমিয়াম',
  'policy.activate': 'সক্রিয় করুন',
  'policy.activating': 'সক্রিয় হচ্ছে...',
  'policy.history': 'পলিসি ইতিহাস',
  'policy.popular': 'জনপ্রিয়',
  'tier.basic': 'বেসিক',
  'tier.standard': 'স্ট্যান্ডার্ড',
  'tier.premium': 'প্রিমিয়াম',
  'tier.basic.desc': 'মাঝে মাঝে কাজ করা কর্মীদের জন্য',
  'tier.standard.desc': 'প্রস্তাবিত',
  'tier.premium.desc': 'সর্বোচ্চ সুরক্ষা',
  'claims.title': 'দাবি',
  'claims.subtitle': 'স্বয়ংক্রিয় আয় সুরক্ষা পেআউট',
  'claims.simulator': 'ব্যাঘাত সিমুলেটর',
  'claims.fireTrigger': 'ট্রিগার ফায়ার করুন →',
  'claims.processingPipeline': 'প্রসেসিং পাইপলাইন...',
  'claims.processed': 'দাবি প্রক্রিয়া করা হয়েছে',
  'claims.predictedLoss': 'পূর্বাভাসিত ক্ষতি',
  'claims.actualEarned': 'প্রকৃত আয়',
  'claims.netLoss': 'নিট ক্ষতি',
  'claims.coverage': 'কভারেজ',
  'claims.payout': 'পেআউট',
  'claims.fraudScore': 'জালিয়াতি স্কোর',
  'claims.ppcs': 'পিপিসিএস',
  'claims.decision': 'সিদ্ধান্ত',
  'claims.history': 'দাবির ইতিহাস',
  'claims.noClaims': 'এখনও কোনো দাবি নেই। পাইপলাইন অ্যাকশনে দেখতে উপরে একটি ব্যাঘাত সিমুলেট করুন।',
  'onboard.getStarted': 'শুরু করুন',
  'onboard.enterPhone': 'ওটিপি যাচাইকরণ দিয়ে শুরু করতে আপনার ফোন নম্বর লিখুন।',
  'onboard.mobile': 'মোবাইল নম্বর',
  'onboard.sendOtp': 'ওটিপি পাঠান →',
  'onboard.sending': 'পাঠানো হচ্ছে...',
  'onboard.terms': 'চালিয়ে যাওয়ার মাধ্যমে, আপনি আমাদের শর্তাবলীতে সম্মত হচ্ছেন।',
  'onboard.verifyOtp': 'ওটিপি যাচাই করুন',
  'onboard.sentTo': 'পাঠানো হয়েছে +91',
  'onboard.otpLabel': '৬-সংখ্যার ওটিপি',
  'onboard.verifyBtn': 'ওটিপি যাচাই করুন →',
  'onboard.verifying': 'যাচাই করা হচ্ছে...',
  'onboard.backPhone': 'ফোন নম্বরে ফিরে যান',
  'onboard.profile': 'আপনার প্রোফাইল',
  'onboard.profileDesc': 'আপনার এবং আপনার ডেলিভারি কাজ সম্পর্কে আমাদের বলুন।',
  'onboard.fullName': 'পুরো নাম',
  'onboard.aadhaar': 'আধার শেষ ৪ সংখ্যা',
  'onboard.upiId': 'ইউপিআই আইডি',
  'onboard.platforms': 'প্ল্যাটফর্ম',
  'onboard.continue': 'চালিয়ে যান →',
  'onboard.workArea': 'আপনার কর্মক্ষেত্র',
  'onboard.workAreaDesc': 'প্রিমিয়াম, ঝুঁকি অঞ্চল এবং পেআউট উইন্ডো গণনা করতে ব্যবহৃত হয়।',
  'onboard.city': 'শহর',
  'onboard.selectCity': 'শহর নির্বাচন করুন',
  'onboard.zone': 'অঞ্চল',
  'onboard.selectZone': 'অঞ্চল নির্বাচন করুন',
  'onboard.weeklyIncome': 'সাপ্তাহিক আয়',
  'onboard.activateKavach': 'কভচ সক্রিয় করুন →',
  'onboard.creatingAccount': 'অ্যাকাউন্ট তৈরি করা হচ্ছে...',
  'onboard.back': 'ফিরে যান',
  'onboard.fillRequired': 'অনুগ্রহ করে সমস্ত প্রয়োজনীয় ক্ষেত্র পূরণ করুন',
  'onboard.about': 'সম্পর্কিত',
  'onboard.howItWorks': 'কীভাবে কাজ করে',
  'onboard.faqs': 'সাধারণ জিজ্ঞাস্য',
  'onboard.whyKavach': 'কেন ডেলিভারি পার্টনাররা কভচ বেছে নেয়',
  'onboard.builtFor': 'ভারতের গিগ ইকোনমি কর্মীদের জন্য বিশেষভাবে তৈরি',
  'onboard.howTitle': 'কভচ কীভাবে কাজ করে',
  'onboard.faqTitle': 'সাধারণ জিজ্ঞাস্য',
  'onboard.faqSubtitle': 'কভচ সম্পর্কে আপনার যা জানা দরকার',
  'hero.badge': 'ভারতের প্রথম এআই ইনকাম শিল্ড',
  'hero.title1': 'যে পলিসিটি',
  'hero.title2': 'আপনার সাথে চলে',
  'hero.desc': 'ভারতের গিগ ডেলিভারি পার্টনারদের জন্য এআই-চালিত আয় সুরক্ষা। রিয়েল-টাইম ডেটা ব্যবহার করে স্বয়ংক্রিয় পেআউট।',
  'hero.stat1.value': '১০,০০০+',
  'hero.stat1.label': 'ডেলিভারি পার্টনার',
  'hero.stat2.label': 'দাবি নিষ্পত্তি',
  'hero.stat3.value': '<৬০ সে',
  'hero.stat3.label': 'গড় প্রসেসিং',
  'hero.stat4.value': '১৬ শহর',
  'hero.stat4.label': 'কভারেজ নেটওয়ার্ক',
  'hero.testimonial': "'অবশেষে, গিগ কর্মীদের জন্য একটি ইনকাম শিল্ড তৈরি করা হয়েছে।'",
  'hero.testimonialSub': 'সার্ভার-ভেরিফাইড ট্রিগার, এমএল-ভিত্তিক ক্ষতি পূর্বাভাস, সরাসরি পেআউট।',
  'feature.weather.title': 'আবহাওয়া সুরক্ষা',
  'feature.weather.desc': 'বৃষ্টি বা বন্যায় আপনার ডেলিভারি ব্যাহত হলে স্বয়ংক্রিয় পেআউট',
  'feature.instant.title': 'তাত্ক্ষণিক দাবি',
  'feature.instant.desc': 'এআই এক মিনিটেরও কম সময়ে দাবিগুলি যাচাই এবং প্রক্রিয়া করে',
  'feature.upi.title': 'ইউপিআই পেআউট',
  'feature.upi.desc': 'কোনও কাগজপত্র ছাড়াই সরাসরি আপনার ইউপিআই-তে পেআউট',
  'feature.weekly.title': 'সাপ্তাহিক প্ল্যান',
  'feature.weekly.desc': 'ডেলিভারি কাজের জন্য তৈরি নমনীয় সাপ্তাহিক কভারেজ',
  'step.register': 'নিবন্ধন',
  'step.register.desc': 'আপনার ফোন নম্বর এবং ডেলিভারি প্ল্যাটফর্মের বিবরণ দিয়ে সাইন আপ করুন',
  'step.plan': 'একটি প্ল্যান চয়ন করুন',
  'step.plan.desc': 'বেসিক, স্ট্যান্ডার্ড বা প্রিমিয়াম সাপ্তাহিক কভারেজ বেছে নিন',
  'step.protected': 'সুরক্ষিত থাকুন',
  'step.protected.desc': 'এআই আপনার ডেলিভারি জোনে আবহাওয়া, একিউআই এবং ব্যাঘাতগুলি পর্যবেক্ষণ করে',
  'step.paid': 'অর্থ প্রদান পান',
  'step.paid.desc': 'ব্যাঘাত সনাক্ত হলে আপনার ইউপিআই-তে স্বয়ংক্রিয় পেআউট',
  'faq.q1': 'কভচ কী?',
  'faq.a1': 'কভচ হল গিগ ডেলিভারি পার্টনারদের জন্য একটি এআই-চালিত আয় সুরক্ষা প্ল্যাটফর্ম।',
  'faq.q2': 'পেআউট কীভাবে কাজ করে?',
  'faq.a2': 'যখন আপনার ডেলিভারি জোনে একটি ট্রिগার সনাক্ত করা হয়, তখন সিস্টেম স্বয়ংক্রিয়ভাবে পেআউট গণনা করে।',
  'faq.q3': 'কভারেজ টিয়ারগুলি কী কী?',
  'faq.a3': 'আমরা তিনটি টিয়ার অফার করি - বেসিক, স্ট্যান্ডার্ড এবং প্রিমিয়াম।',
  'faq.q4': 'দাবিগুলি কীভাবে যাচাই করা হয়?',
  'faq.a4': 'সরকারি ডেটা ব্যবহার করে স্বয়ংক্রিয়ভাবে যাচাই করা হয়।',
  'faq.q5': 'আমি কি আমার পলিসি বাতিল করতে পারি?',
  'faq.a5': 'হ্যাঁ, আপনি যে কোনও সময় পলিসি বাতিল করতে পারেন।',
  'faq.q6': 'কোন শহরগুলি সমর্থিত?',
  'faq.a6': 'বর্তমানে ১৬টি প্রধান ভারতীয় শহরে কভচ সমর্থিত।',
  'footer.tagline': 'যে পলিসিটি আপনার সাথে চলে',
  'footer.privacy': 'গোপনীয়তা নীতি',
  'footer.terms': 'পরিষেবার শর্তাবলী',
  'footer.contact': 'যোগাযোগ করুন',
  'footer.copyright': '© ২০২৬ কভচ এআই ইনস্যুরেন্স। সর্বস্বত্ব সংরক্ষিত।',
  'onboard.shiftStart': 'শিফটের শুরু',
  'onboard.shiftEnd': 'শিফটের শেষ',
  'onboard.workingDays': 'কাজের দিন',
  'onboard.workingHours': 'কাজের ঘন্টা',
  'onboard.partTime': 'পার্ট-টাইম (৪-৬ ঘন্টা)',
  'onboard.fullTime': 'ফুল-টাইম (৮-১২ ঘন্টা)',
  'onboard.extended': 'বর্ধিত (১২-১৬ ঘন্টা)',
  'onboard.devOtp': 'ডেভ ওটিপি',
};

const te = {
  ...en,
  'app.tagline': 'డెలివరీ భాగస్వాముల కోసం ఆదాయ రక్షణ',
  'common.loading': 'లోడ్ అవుతోంది...',
  'common.logout': 'లాగ్ అవుట్',
  'nav.dashboard': 'హోమ్',
  'nav.policy': 'పాలసీ',
  'nav.claims': 'క్లెయిమ్స్',
  'nav.admin': 'అడ్మిన్',
  'dash.greeting.morning': 'శుభోదయం',
  'dash.greeting.afternoon': 'శుభ మధ్యాహ్నం',
  'dash.greeting.evening': 'శుభ సాయంత్రం',
  'dash.weeklyCoverage': 'వారపు కవరేజ్',
  'dash.noActivePolicy': 'సక్రియ పాలసీ లేదు',
  'dash.activatePolicy': 'వారపు పాలసీ యాక్టివేట్ చేయండి →',
  'dash.weeklyPremium': 'వారపు ప్రీమియం',
  'dash.recentClaims': 'ఇటీవల క్లెయిమ్స్',
  'dash.claimsFree': 'క్లెయిమ్స్-ఫ్రీ',
  'dash.liveMonitor': 'లైవ్ అంతరాయ మానిటర్',
  'dash.noDisruption': 'ప్రస్తుతం లైవ్ డేటా లేదు.',
  'dash.simulateTitle': 'డిస్రప్షన్ సిమ్యులేట్ చేయండి',
  'dash.simulateDesc': 'బ్యాకెండ్ రాజీ లేకుండా ఆటోమేటెడ్ క్లెయిమ్ రన్ చేయండి.',
  'dash.simulateBtn': 'రైన్ క్లెయిమ్ సిమ్యులేట్ చేయండి',
  'dash.processing': 'ప్రాసెస్ అవుతోంది...',
  'dash.noClaims': 'ఇంకా క్లెయిమ్స్ లేవు.',
  'dash.viewAll': 'అన్నింటినీ చూడండి →',
  'dash.workSchedule': 'పని షెడ్యూల్',
  'dash.workingHours': 'పని గంటలు',
  'dash.partTime': 'పార్ట్-టైమ్ (4-6 గంటలు/రోజు)',
  'dash.fullTime': 'ఫుల్-టైమ్ (8-12 గంటలు/రోజు)',
  'dash.extended': 'ఎక్స్‌టెండెడ్ (12-16 గంటలు/రోజు)',
  'dash.shiftStart': 'షిఫ్ట్ ప్రారంభం',
  'dash.shiftEnd': 'షిఫ్ట్ ముగింపు',
  'dash.workingDays': 'పని దినాలు',
  'dash.saveSchedule': 'షెడ్యూల్ సేవ్ చేయండి',
  'dash.saving': 'సేవ్ అవుతోంది...',
  'policy.title': 'బీమా పాలసీ',
  'policy.subtitle': 'ప్రతి సోమవారం పునరుద్ధరించే వారపు ఆదాయ రక్షణ',
  'policy.active': 'యాక్టివ్',
  'policy.protected': 'రక్షితం',
  'policy.expires': 'గడువు ముగుస్తుంది',
  'policy.cancel': 'పాలసీ రద్దు చేయండి',
  'policy.chooseTier': 'కవరేజ్ టైర్ ఎంచుకోండి',
  'policy.premiumBreakdown': 'ప్రీమియం వివరాలు',
  'policy.perWeek': 'వారానికి · సోమవారం UPI ఆటోపే',
  'policy.maxPayout': 'గరిష్ట చెల్లింపు',
  'policy.baseRate': 'బేస్ రేట్',
  'policy.zoneRisk': 'జోన్ రిస్క్ ఫ్యాక్టర్',
  'policy.seasonMul': 'సీజన్ మల్టిప్లైయర్',
  'policy.claimsFreeDisc': 'క్లెయిమ్ ఫ్రీ డిస్కౌంట్',
  'policy.surgeLoading': 'సర్జ్ లోడింగ్',
  'policy.tierMul': 'టైర్ మల్టిప్లైయర్',
  'policy.weeklyPremium': 'వారపు ప్రీమియం',
  'policy.activate': 'యాక్టివేట్ చేయండి',
  'policy.activating': 'యాక్టివేట్ అవుతోంది...',
  'policy.history': 'పాలసీ చరిత్ర',
  'policy.popular': 'పాపులర్',
  'tier.basic': 'బేసిక్',
  'tier.standard': 'స్టాండర్డ్',
  'tier.premium': 'ప్రీమియం',
  'tier.basic.desc': 'అప్పుడప్పుడు పనిచేసేవారికి',
  'tier.standard.desc': 'సిఫార్సు చేయబడింది',
  'tier.premium.desc': 'గరిష్ట రక్షణ',
  'claims.title': 'క్లెయిమ్స్',
  'claims.subtitle': 'ఆటోమేటెడ్ ఆదాయ రక్షణ చెల్లింపులు',
  'claims.simulator': 'అంతరాయ సిమ్యులేటర్',
  'claims.fireTrigger': 'ట్రిగ్గర్ చేయండి →',
  'claims.processingPipeline': 'ప్రాసెసింగ్ పైప్‌లైన్...',
  'claims.processed': 'క్లెయిమ్ ప్రాసెస్ చేయబడింది',
  'claims.predictedLoss': 'అంచనా వేసిన నష్టం',
  'claims.actualEarned': 'వాస్తవ ఆదాయం',
  'claims.netLoss': 'నికర నష్టం',
  'claims.coverage': 'కవరేజ్',
  'claims.payout': 'చెల్లింపు',
  'claims.fraudScore': 'ఫ్రాడ్ స్కోరు',
  'claims.ppcs': 'PPCS',
  'claims.decision': 'నిర్ణయం',
  'claims.history': 'క్లెయిమ్స్ చరిత్ర',
  'claims.noClaims': 'ఇంకా క్లెయిమ్స్ లేవు.',
  'onboard.getStarted': 'ప్రారంభించండి',
  'onboard.enterPhone': 'OTP ధృవీకరణ కోసం ఫోన్ నంబర్‌ను నమోదు చేయండి.',
  'onboard.mobile': 'మొబైల్ నంబర్',
  'onboard.sendOtp': 'OTP పంపండి →',
  'onboard.sending': 'పంపుతోంది...',
  'onboard.terms': 'కొనసాగించడం ద్వారా, మీరు నిబంధనలకు అంగీకరిస్తున్నారు.',
  'onboard.verifyOtp': 'OTP ధృవీకరించండి',
  'onboard.sentTo': 'క్రింది నంబర్‌కు పంపబడింది +91',
  'onboard.otpLabel': '6-అంకెల OTP',
  'onboard.verifyBtn': 'OTP ధృవీకరించండి →',
  'onboard.verifying': 'ధృవీకరిస్తోంది...',
  'onboard.backPhone': 'వెనుకకు',
  'onboard.profile': 'మీ ప్రొఫైల్',
  'onboard.profileDesc': 'మీ గురించి మరియు డెలివరీ పని గురించి చెప్పండి.',
  'onboard.fullName': 'పూర్తి పేరు',
  'onboard.aadhaar': 'ఆధార్ చివరి 4 అంకెలు',
  'onboard.upiId': 'UPI ID',
  'onboard.platforms': 'ప్లాట్‌ఫారమ్‌లు',
  'onboard.continue': 'కొనసాగండి →',
  'onboard.workArea': 'మీ పని ప్రాంతం',
  'onboard.workAreaDesc': 'ప్రీమియం, రిస్క్ జోన్ లెక్కించడానికి ఉపయోగించబడుతుంది.',
  'onboard.city': 'నగరం',
  'onboard.selectCity': 'నగరాన్ని ఎంచుకోండి',
  'onboard.zone': 'జోన్',
  'onboard.selectZone': 'జోన్ ఎంచుకోండి',
  'onboard.weeklyIncome': 'వారపు ఆదాయం',
  'onboard.activateKavach': 'KAVACH యాక్టివేట్ చేయండి →',
  'onboard.creatingAccount': 'ఖాతాను సృష్టిస్తోంది...',
  'onboard.back': 'వెనుకకు',
  'onboard.fillRequired': 'దయచేసి అన్ని ఫీల్డ్‌లను పూరించండి',
  'onboard.about': 'గురించి',
  'onboard.howItWorks': 'ఎలా పనిచేస్తుంది',
  'onboard.faqs': 'FAQs',
  'onboard.whyKavach': 'డెలివరీ పార్టనర్లు KAVACH ను ఎందుకు ఎంచుకుంటారు',
  'onboard.builtFor': 'భారతదేశ డెలివరీ కార్మికుల కోసం రూపొందించబడింది',
  'onboard.howTitle': 'KAVACH ఎలా పనిచేస్తుంది',
  'onboard.faqTitle': 'తరచుగా అడిగే ప్రశ్నలు',
  'onboard.faqSubtitle': 'KAVACH గురించి తెలుసుకోండి',
  'hero.badge': "భారతదేశపు మొదటి AI ఆదాయ కవచం",
  'hero.title1': 'మీతో ప్రయాణించే',
  'hero.title2': 'పాలసీ',
  'hero.desc': 'AI-పవర్డ్ ప్లాట్‌ఫారమ్. వర్షం, వరదలు, ఆగిపోవడం నుండి రక్షణ.',
  'hero.stat1.value': '10,000+',
  'hero.stat1.label': 'డెలివరీ పార్టనర్లు',
  'hero.stat2.label': 'క్లెయిమ్స్',
  'hero.stat3.value': '<60s',
  'hero.stat3.label': 'ఆటో ప్యావుట్',
  'hero.stat4.value': '16',
  'hero.stat4.label': 'నగరాలు',
  'hero.testimonial': "'అద్భుతమైన ప్లాట్‌ఫారమ్.'",
  'hero.testimonialSub': 'తక్షణ ఆదాయ రక్షణ.',
  'feature.weather.title': 'వాతావరణ రక్షణ',
  'feature.weather.desc': 'వర్షం లేదా వరదలు ఉన్నప్పుడు ఆటో-ప్యావుట్',
  'feature.instant.title': 'తక్షణ క్లెయిమ్స్',
  'feature.instant.desc': 'AI ద్వారా 60 సెకన్లలో ప్రాసెసింగ్',
  'feature.upi.title': 'UPI ప్యావుట్',
  'feature.upi.desc': 'మీ UPI కు నేరుగా నగదు',
  'feature.weekly.title': 'వారాంతపు ప్లాన్',
  'feature.weekly.desc': 'ఫ్లెక్సిబుల్ కవరేజ్',
  'step.register': 'నమోదు చేసుకోండి',
  'step.register.desc': 'మీ ఫోన్ నంబర్‌తో సైన్ అప్ చేయండి',
  'step.plan': 'ప్లాన్ ఎంచుకోండి',
  'step.plan.desc': 'టైర్ ఎంచుకోండి',
  'step.protected': 'రక్షణలో ఉండండి',
  'step.protected.desc': 'AI మీ పనిని పర్యవేక్షిస్తుంది',
  'step.paid': 'నగదు పొందండి',
  'step.paid.desc': 'ఆటోమేటిక్ UPI చెల్లింపు',
  'faq.q1': 'KAVACH అంటే ఏమిటి?',
  'faq.a1': 'ఇది డెలివరీ వర్కర్లకు ఒక బీమా ప్లాట్‌ఫారమ్.',
  'faq.q2': 'చెల్లింపు ఎలా జరుగుతుంది?',
  'faq.a2': 'ఆటోమేటిక్‌గా UPI ద్వారా జరుగుతుంది.',
  'faq.q3': 'టైర్లు ఏమిటి?',
  'faq.a3': 'బేసిక్, స్టాండర్డ్, మరియు ప్రీమియం.',
  'faq.q4': 'క్లెయిమ్ ఎలా వెరిఫై చేస్తారు?',
  'faq.a4': 'సర్వర్ డేటా ద్వారా.',
  'faq.q5': 'నేను క్యాన్సిల్ చేయవచ్చా?',
  'faq.a5': 'అవును, ఎప్పుడైనా చేయవచ్చు.',
  'faq.q6': 'ఏ నగరాలు ఉన్నాయి?',
  'faq.a6': '16 ప్రధాన నగరాలు.',
  'footer.tagline': 'మీతో ప్రయాణించే పాలసీ',
  'footer.privacy': 'గోప్యతా విధానం',
  'footer.terms': 'సేవా నిబంధనలు',
  'footer.contact': 'మమ్మల్ని సంప్రదించండి',
  'footer.copyright': '© 2026 KAVACH. అన్ని హక్కులు ప్రత్యేకించబడ్డాయి.',
  'onboard.shiftStart': 'షిఫ్ట్ ప్రారంభం',
  'onboard.shiftEnd': 'షిఫ్ట్ ముగింపు',
  'onboard.workingDays': 'పని రోజులు',
  'onboard.workingHours': 'పని గంటలు',
  'onboard.partTime': 'పార్ట్-టైమ్',
  'onboard.fullTime': 'ఫుల్-టైమ్',
  'onboard.extended': 'ఎక్స్‌టెండెడ్',
  'onboard.devOtp': 'Dev OTP',
};

const mr = {
  ...en,
  'app.tagline': 'डिलिव्हरी पार्टनर्ससाठी उत्पन्न संरक्षण',
  'common.loading': 'लोड होत आहे...',
  'common.logout': 'लॉग आउट',
  'nav.dashboard': 'होम',
  'nav.policy': 'पॉलिसी',
  'nav.claims': 'क्लेम्स',
  'nav.admin': 'अॅडमिन',
  'dash.greeting.morning': 'सुप्रभात',
  'dash.greeting.afternoon': 'शुभ दुपार',
  'dash.greeting.evening': 'शुभ संध्याकाळ',
  'dash.weeklyCoverage': 'साप्ताहिक कव्हरेज',
  'dash.noActivePolicy': 'सक्रिय पॉलिसी नाही',
  'dash.activatePolicy': 'साप्ताहिक पॉलिसी सक्रिय करा →',
  'dash.weeklyPremium': 'साप्ताहिक प्रीमियम',
  'dash.recentClaims': 'अलीकडील क्लेम्स',
  'dash.claimsFree': 'क्लेम-मुक्त',
  'dash.liveMonitor': 'थेट व्यत्यय मॉनिटर',
  'dash.noDisruption': 'सध्या कोणताही लाइव्ह डेटा नाही.',
  'dash.simulateTitle': 'व्यत्यय सिम्युलेट करा',
  'dash.simulateDesc': 'ऑटोमेटेड क्लेम पाइपलाइन रन करा.',
  'dash.simulateBtn': 'पाऊस क्लेम सिम्युलेट करा',
  'dash.processing': 'प्रोसेसिंग...',
  'dash.noClaims': 'अजून कोणतेही क्लेम नाहीत.',
  'dash.viewAll': 'सर्व पहा →',
  'dash.workSchedule': 'कार्य वेळापत्रक',
  'dash.workingHours': 'कामाचे तास',
  'dash.partTime': 'पार्ट-टाइम (4-6 तास/दिवस)',
  'dash.fullTime': 'फुल-टाइम (8-12 तास/दिवस)',
  'dash.extended': 'एक्स्टेंडेड (12-16 तास/दिवस)',
  'dash.shiftStart': 'शिफ्ट सुरू',
  'dash.shiftEnd': 'शिफ्ट समाप्त',
  'dash.workingDays': 'कामाचे दिवस',
  'dash.saveSchedule': 'वेळापत्रक सेव्ह करा',
  'dash.saving': 'सेव्ह होत आहे...',
  'policy.title': 'विमा पॉलिसी',
  'policy.subtitle': 'दर सोमवारी नूतनीकरण होणारे साप्ताहिक उत्पन्न संरक्षण',
  'policy.active': 'सक्रिय',
  'policy.protected': 'संरक्षित',
  'policy.expires': 'कालबाह्य',
  'policy.cancel': 'पॉलिसी रद्द करा',
  'policy.chooseTier': 'कव्हरेज टियर निवडा',
  'policy.premiumBreakdown': 'प्रीमियम तपशील',
  'policy.perWeek': 'प्रति आठवडा · UPI ऑटोपे',
  'policy.maxPayout': 'कमाल पेआउट',
  'policy.baseRate': 'मूळ दर',
  'policy.zoneRisk': 'झोन जोखीम',
  'policy.seasonMul': 'सीझन मल्टिप्लायर',
  'policy.claimsFreeDisc': 'क्लेम-मुक्त सवलत',
  'policy.surgeLoading': 'सर्ज लोडिंग',
  'policy.tierMul': 'टियर मल्टिप्लायर',
  'policy.weeklyPremium': 'साप्ताहिक प्रीमियम',
  'policy.activate': 'सक्रिय करा',
  'policy.activating': 'सक्रिय करत आहे...',
  'policy.history': 'पॉलिसी इतिहास',
  'policy.popular': 'लोकप्रिय',
  'tier.basic': 'बेसिक',
  'tier.standard': 'स्टँडर्ड',
  'tier.premium': 'प्रीमियम',
  'tier.basic.desc': 'कधीतरी काम करणारे',
  'tier.standard.desc': 'शिफारस केलेले',
  'tier.premium.desc': 'कमाल संरक्षण',
  'claims.title': 'क्लेम्स',
  'claims.subtitle': 'स्वयंचलित उत्पन्न संरक्षण देयके',
  'claims.simulator': 'व्यत्यय सिम्युलेटर',
  'claims.fireTrigger': 'ट्रिगर करा →',
  'claims.processingPipeline': 'पाइपलाइन प्रोसेसिंग...',
  'claims.processed': 'क्लेम प्रोसेस झाला',
  'claims.predictedLoss': 'अपेक्षित नुकसान',
  'claims.actualEarned': 'प्रत्यक्ष कमाई',
  'claims.netLoss': 'निव्वळ नुकसान',
  'claims.coverage': 'कव्हरेज',
  'claims.payout': 'पेआउट',
  'claims.fraudScore': 'फसवणूक स्कोअर',
  'claims.ppcs': 'PPCS',
  'claims.decision': 'निर्णय',
  'claims.history': 'क्लेम्स इतिहास',
  'claims.noClaims': 'अजून कोणतेही क्लेम नाहीत.',
  'onboard.getStarted': 'सुरू करा',
  'onboard.enterPhone': 'तुमचा फोन नंबर एंटर करा.',
  'onboard.mobile': 'मोबाईल नंबर',
  'onboard.sendOtp': 'OTP पाठवा →',
  'onboard.sending': 'पाठवत आहे...',
  'onboard.terms': 'पुढे जाऊन, तुम्ही आमच्या अटींशी सहमत आहात.',
  'onboard.verifyOtp': 'OTP पडताळा',
  'onboard.sentTo': '+91 वर पाठवला',
  'onboard.otpLabel': '6-अंकी OTP',
  'onboard.verifyBtn': 'OTP पडताळा →',
  'onboard.verifying': 'पडताळणी करत आहे...',
  'onboard.backPhone': 'मागे जा',
  'onboard.profile': 'तुमचे प्रोफाइल',
  'onboard.profileDesc': 'तुमची माहिती द्या.',
  'onboard.fullName': 'पूर्ण नाव',
  'onboard.aadhaar': 'आधारचे शेवटचे 4 अंक',
  'onboard.upiId': 'UPI ID',
  'onboard.platforms': 'प्लॅटफॉर्म्स',
  'onboard.continue': 'पुढे जा →',
  'onboard.workArea': 'तुमचे कार्यक्षेत्र',
  'onboard.workAreaDesc': 'प्रीमियम आणि जोखीम मोजण्यासाठी.',
  'onboard.city': 'शहर',
  'onboard.selectCity': 'शहर निवडा',
  'onboard.zone': 'झोन',
  'onboard.selectZone': 'झोन निवडा',
  'onboard.weeklyIncome': 'साप्ताहिक उत्पन्न',
  'onboard.activateKavach': 'KAVACH सक्रिय करा →',
  'onboard.creatingAccount': 'खाते तयार करत आहे...',
  'onboard.back': 'मागे',
  'onboard.fillRequired': 'कृपया सर्व फील्ड भरा',
  'onboard.about': 'बद्दल',
  'onboard.howItWorks': 'हे कसे काम करते',
  'onboard.faqs': 'FAQs',
  'onboard.whyKavach': 'डिलिव्हरी पार्टनर KAVACH का निवडतात',
  'onboard.builtFor': 'भारतातील गिग कामगारांसाठी खास',
  'onboard.howTitle': 'KAVACH कसे काम करते',
  'onboard.faqTitle': 'वरंवार विचारले जाणारे प्रश्न',
  'onboard.faqSubtitle': 'KAVACH बद्दलची माहिती',
  'hero.badge': "भारतातील पहिले AI उत्पन्न चिलखत",
  'hero.title1': 'तुमच्यासोबत',
  'hero.title2': 'असणारी पॉलिसी',
  'hero.desc': 'AI-सक्षम उत्पन्न संरक्षण.',
  'hero.stat1.value': '10,000+',
  'hero.stat1.label': 'डिलिव्हरी पार्टनर्स',
  'hero.stat2.label': 'क्लेम्स',
  'hero.stat3.value': '<60s',
  'hero.stat3.label': 'पेआउट',
  'hero.stat4.value': '16 शहर',
  'hero.stat4.label': 'कव्हरेज',
  'hero.testimonial': "'उत्कृष्ट पॉलिसी.'",
  'hero.testimonialSub': 'वेळेवर देयके.',
  'feature.weather.title': 'हवामान संरक्षण',
  'feature.weather.desc': 'पाऊस किंवा पुरामध्ये ऑटो-पेआउट',
  'feature.instant.title': 'इन्स्टंट क्लेम',
  'feature.instant.desc': '60 सेकंदात क्लेम',
  'feature.upi.title': 'UPI पेआउट',
  'feature.upi.desc': 'थेट तुमच्या UPI वर',
  'feature.weekly.title': 'साप्ताहिक योजना',
  'feature.weekly.desc': 'लवचिक कव्हरेज',
  'step.register': 'नोंदणी करा',
  'step.register.desc': 'तुमच्या फोन नंबरने साइन अप करा',
  'step.plan': 'प्लॅन निवडा',
  'step.plan.desc': 'टियर निवडा',
  'step.protected': 'सुरक्षित रहा',
  'step.protected.desc': 'AI तुमच्या झोनवर लक्ष ठेवते',
  'step.paid': 'पैसे मिळवा',
  'step.paid.desc': 'थेट UPI वर',
  'faq.q1': 'KAVACH काय आहे?',
  'faq.a1': 'हे गिग कामगारांसाठी विमा आहे.',
  'faq.q2': 'पेआउट कसे काम करते?',
  'faq.a2': 'ऑटोमॅटिक जनरेट होते.',
  'faq.q3': 'कोणते कव्हरेज आहेत?',
  'faq.a3': 'बेसिक, स्टँडर्ड आणि प्रीमियम.',
  'faq.q4': 'क्लेम कसे मोजले जातात?',
  'faq.a4': 'AI द्वारे.',
  'faq.q5': 'रद्द करता येते का?',
  'faq.a5': 'होय.',
  'faq.q6': 'किती शहरात आहे?',
  'faq.a6': '16 प्रमुख शहरांमध्ये.',
  'footer.tagline': 'तुमच्यासोबत असणारी पॉलिसी',
  'footer.privacy': 'गोपनीयता धोरण',
  'footer.terms': 'सेवा अटी',
  'footer.contact': 'आमच्याशी संपर्क साधा',
  'footer.copyright': '© 2026 KAVACH.',
  'onboard.shiftStart': 'शिफ्ट सुरू',
  'onboard.shiftEnd': 'शिफ्ट समाप्त',
  'onboard.workingDays': 'कामाचे दिवस',
  'onboard.workingHours': 'कामाचे तास',
  'onboard.partTime': 'पार्ट-टाइम',
  'onboard.fullTime': 'फुल-टाइम',
  'onboard.extended': 'एक्स्टेंडेड',
  'onboard.devOtp': 'Dev OTP',
};

const ta = {
  ...en,
  'app.tagline': 'டெலிவரி பணியாளர்களுக்கான வருமான பாதுகாப்பு',
  'common.loading': 'ஏற்றப்படுகிறது...',
  'common.logout': 'வெளியேறு',
  'nav.dashboard': 'முகப்பு',
  'nav.policy': 'பாலிசி',
  'nav.claims': 'கோரிக்கைகள்',
  'nav.admin': 'அட்மின்',
  'dash.greeting.morning': 'காலை வணக்கம்',
  'dash.greeting.afternoon': 'மதிய வணக்கம்',
  'dash.greeting.evening': 'மாலை வணக்கம்',
  'dash.weeklyCoverage': 'வாராந்திர கவரேஜ்',
  'dash.noActivePolicy': 'செயலில் பாலிசி இல்லை',
  'dash.activatePolicy': 'பாலிசையை செயல்படுத்து →',
  'dash.weeklyPremium': 'வாராந்திர பிரீமியம்',
  'dash.recentClaims': 'சமீபத்திய கோரிக்கைகள்',
  'dash.claimsFree': 'கோரிக்கை அற்ற',
  'dash.liveMonitor': 'நேரடி கண்காணிப்பு',
  'dash.noDisruption': 'தரவு இல்லை.',
  'dash.simulateTitle': 'உருவாக்கு',
  'dash.simulateDesc': 'செயல்பாட்டை உருவாக்கு.',
  'dash.simulateBtn': 'மழை கோரிக்கையை உருவாக்கு',
  'dash.processing': 'செயலாக்கபடுகிறது...',
  'dash.noClaims': 'கோரிக்கைகள் இல்லை.',
  'dash.viewAll': 'அனைத்தையும் காண்க →',
  'dash.workSchedule': 'பணி அட்டவணை',
  'dash.workingHours': 'வேலை நேரம்',
  'dash.partTime': 'பகுதிநேர (4-6 மணி/நாள்)',
  'dash.fullTime': 'முழுநேர (8-12 மணி/நாள்)',
  'dash.extended': 'நீட்டிக்கப்பட்ட (12-16 மணி/நாள்)',
  'dash.shiftStart': 'தொடக்கம்',
  'dash.shiftEnd': 'முடிவு',
  'dash.workingDays': 'வேலை நாட்கள்',
  'dash.saveSchedule': 'சேமி',
  'dash.saving': 'சேமிக்கபடுகிறது...',
  'policy.title': 'காப்பீட்டு பாலிசி',
  'policy.subtitle': 'ஒவ்வொரு திங்களும் புதுப்பிக்கப்படும் வாராந்திர வருமான பாதுகாப்பு',
  'policy.active': 'செயலில்',
  'policy.protected': 'பாதுகாக்கப்பட்டது',
  'policy.expires': 'காலாவதி',
  'policy.cancel': 'ரத்து செய்',
  'policy.chooseTier': 'கவரேஜ் நிலையை தேர்வு செய்யவும்',
  'policy.premiumBreakdown': 'பிரீமியம் விவரங்கள்',
  'policy.perWeek': 'வாரத்திற்கு · திங்களில் UPI ஆட்டோபே',
  'policy.maxPayout': 'அதிகபட்சம்',
  'policy.baseRate': 'அடிப்படை',
  'policy.zoneRisk': 'மண்டல அபாயம்',
  'policy.seasonMul': 'பருவகாலம்',
  'policy.claimsFreeDisc': 'கோரிக்கை அற்ற தள்ளுபடி',
  'policy.surgeLoading': 'சர்ஜ் லோடிங்',
  'policy.tierMul': 'டயர் பெருக்கி',
  'policy.weeklyPremium': 'வாராந்திர பிரீமியம்',
  'policy.activate': 'செயல்படுத்து',
  'policy.activating': 'செயல்படுத்தப்படுகிறது...',
  'policy.history': 'பாலிசி வரலாறு',
  'policy.popular': 'பிரபலமான',
  'tier.basic': 'அடிப்படை',
  'tier.standard': 'நிலையான',
  'tier.premium': 'பிரீமியம்',
  'tier.basic.desc': 'அவ்வப்போது வேலை',
  'tier.standard.desc': 'பரிந்துரைக்கப்படுகிறது',
  'tier.premium.desc': 'அதிகபட்ச பாதுகாப்பு',
  'claims.title': 'கோரிக்கைகள்',
  'claims.subtitle': 'தானியங்கு வருமான பாதுகாப்பு செலுத்தல்',
  'claims.simulator': 'உருவாக்கி',
  'claims.fireTrigger': 'செயல்படுத்து →',
  'claims.processingPipeline': 'செயலாக்கம்...',
  'claims.processed': 'செயலாக்கப்பட்டது',
  'claims.predictedLoss': 'இழப்பு',
  'claims.actualEarned': 'சம்பாதித்தது',
  'claims.netLoss': 'நிகர இழப்பு',
  'claims.coverage': 'கவரேஜ்',
  'claims.payout': 'செலுத்துதல்',
  'claims.fraudScore': 'மோசடி மதிப்பெண்',
  'claims.ppcs': 'PPCS',
  'claims.decision': 'முடிவு',
  'claims.history': 'கோரிக்கை வரலாறு',
  'claims.noClaims': 'கோரிக்கைகள் இல்லை.',
  'onboard.getStarted': 'தொடங்குங்கள்',
  'onboard.enterPhone': 'உங்கள் மொபைல் எண்ணை உள்ளிடவும்.',
  'onboard.mobile': 'மொபைல் எண்',
  'onboard.sendOtp': 'OTP அனுப்பு →',
  'onboard.sending': 'அனுப்புகிறது...',
  'onboard.terms': 'எங்கள் விதிமுறைகளை ஏற்கிறீர்கள்.',
  'onboard.verifyOtp': 'OTP சரிபார்',
  'onboard.sentTo': 'அனுப்பப்பட்ட எண் +91',
  'onboard.otpLabel': '6-இலக்க OTP',
  'onboard.verifyBtn': 'OTP சரிபார் →',
  'onboard.verifying': 'சரிபார்க்கிறது...',
  'onboard.backPhone': 'பின் செல்',
  'onboard.profile': 'உங்கள் சுயவிவரம்',
  'onboard.profileDesc': 'தகவல்களை அளிக்கவும்.',
  'onboard.fullName': 'முழு பெயர்',
  'onboard.aadhaar': 'ஆதார் கடைசி 4',
  'onboard.upiId': 'UPI எண்',
  'onboard.platforms': 'தளங்கள்',
  'onboard.continue': 'தொடர்க →',
  'onboard.workArea': 'உங்கள் பணி மண்டலம்',
  'onboard.workAreaDesc': 'மண்டல விபரங்களை தேர்வு செய்.',
  'onboard.city': 'நகரம்',
  'onboard.selectCity': 'நகரை தேர்ந்தெடுக்கவும்',
  'onboard.zone': 'மண்டலம்',
  'onboard.selectZone': 'மண்டலம் தேர்ந்தெடுக்கவும்',
  'onboard.weeklyIncome': 'வாராந்திர வருமானம்',
  'onboard.activateKavach': 'KAVACH செயல்படுத்து →',
  'onboard.creatingAccount': 'கணக்கு உருவாகிறது...',
  'onboard.back': 'பின்',
  'onboard.fillRequired': 'அனைத்து விவரங்களையும் நிரப்பவும்',
  'onboard.about': 'பற்றி',
  'onboard.howItWorks': 'எப்படி',
  'onboard.faqs': 'FAQs',
  'onboard.whyKavach': 'ஏன் KAVACH',
  'onboard.builtFor': 'இந்திய தொழிலாளர்களுக்காக',
  'onboard.howTitle': 'காப்பீடு வேலை செய்யும் முறை',
  'onboard.faqTitle': 'அடிக்கடி கேட்கப்படும் கேள்விகள்',
  'onboard.faqSubtitle': 'விவரங்கள்',
  'hero.badge': "முதல் AI காப்பீடு",
  'hero.title1': 'உங்களுடன் பயணிக்கும்',
  'hero.title2': 'பாலிசி',
  'hero.desc': 'AI மூலம் செயல்படும் காப்பீடு.',
  'hero.stat1.value': '10,000+',
  'hero.stat1.label': 'பணியாளர்கள்',
  'hero.stat2.label': 'கோரிக்கைகள்',
  'hero.stat3.value': '<60s',
  'hero.stat3.label': 'நேரம்',
  'hero.stat4.value': '16 ஊர்கள்',
  'hero.stat4.label': 'நெட்வொர்க்',
  'hero.testimonial': "'அருமையான திட்டம்.'",
  'hero.testimonialSub': 'உடனடி செலுத்துதல்.',
  'feature.weather.title': 'வானிலை பாதுகாப்பு',
  'feature.weather.desc': 'மழைக்காலத்தில் உடனடியாக செலுத்துதல்',
  'feature.instant.title': 'உடனடி கோரிக்கை',
  'feature.instant.desc': 'AI மூலம் ஒரு நிமிடத்தில்',
  'feature.upi.title': 'UPI செட்டில்மென்ட்',
  'feature.upi.desc': 'நேரடியாக UPI இல்',
  'feature.weekly.title': 'வாராந்திர திடம்',
  'feature.weekly.desc': 'சிறந்த கவரேஜ்',
  'step.register': 'பதிவு செய்',
  'step.register.desc': 'மொபைல் எண்ணுடன் பதிவு',
  'step.plan': 'திட்டம் தேர்ந்தெடு',
  'step.plan.desc': 'சரியான திட்டம்',
  'step.protected': 'பாதுகாப்பு',
  'step.protected.desc': 'AI கண்காணிக்கிறது',
  'step.paid': 'பணம் பெறு',
  'step.paid.desc': 'தானியங்கி செலுத்துதல்',
  'faq.q1': 'KAVACH என்றால் என்ன?',
  'faq.a1': 'ஒரு சிறந்த காப்பீடு.',
  'faq.q2': 'எப்படி பணம் வரும்?',
  'faq.a2': 'UPI மூலமாக.',
  'faq.q3': 'எத்தனை திட்டங்கள்?',
  'faq.a3': 'மூன்று திட்டங்கள் உள்ளன.',
  'faq.q4': 'AI எப்படி செயல் படும்?',
  'faq.a4': 'தன்னியக்கமாக.',
  'faq.q5': 'ரத்து செய்யலாமா?',
  'faq.a5': 'ஆம்.',
  'faq.q6': 'எந்த ஊர்களில்?',
  'faq.a6': '16 ஊர்களில்.',
  'footer.tagline': 'உங்களுடன் பயணிக்கும் காப்பீடு',
  'footer.privacy': 'தனியுரிமை',
  'footer.terms': 'விதிமுறைகள்',
  'footer.contact': 'தொடர்பு கொள்க',
  'footer.copyright': '© 2026 KAVACH.',
  'onboard.shiftStart': 'ஆரம்பம்',
  'onboard.shiftEnd': 'முடிவு',
  'onboard.workingDays': 'நாட்கள்',
  'onboard.workingHours': 'நேரம்',
  'onboard.partTime': 'பகுதி நேரம்',
  'onboard.fullTime': 'முழு நேரம்',
  'onboard.extended': 'நீட்டிக்கப்பட்ட',
  'onboard.devOtp': 'Dev OTP',
};

const kn = {
  ...en,
  'app.tagline': 'ಡೆಲಿವರಿ ಪಾಲುದಾರರಿಗೆ ಆದಾಯ ರಕ್ಷಣೆ',
  'common.loading': 'ಲೋಡ್ ಆಗುತ್ತಿದೆ...',
  'common.logout': 'ಲಾಗ್ ಔಟ್',
  'nav.dashboard': 'ಮುಖಪುಟ',
  'nav.policy': 'ಪಾಲಿಸಿ',
  'nav.claims': 'ಕ್ಲೈಮ್ಸ್',
  'nav.admin': 'ಅಡ್ಮಿನ್',
  'dash.greeting.morning': 'ಶುಭೋದಯ',
  'dash.greeting.afternoon': 'ಶುಭ ಮಧ್ಯಾಹ್ನ',
  'dash.greeting.evening': 'ಶುಭ ಸಂಜೆ',
  'dash.weeklyCoverage': 'ವಾರದ ಕವರೇಜ್',
  'dash.noActivePolicy': 'ಸಕ್ರಿಯ ಪಾಲಿಸಿ ಇಲ್ಲ',
  'dash.activatePolicy': 'ಪಾಲಿಸಿ ಸಕ್ರಿಯಗೊಳಿಸಿ →',
  'dash.weeklyPremium': 'ವಾರದ ಪ್ರೀಮಿಯಂ',
  'dash.recentClaims': 'ಇತ್ತೀಚಿನ ಕ್ಲೈಮ್ಸ್',
  'dash.claimsFree': 'ಕ್ಲೈಮ್-ಮುಕ್ತ',
  'dash.liveMonitor': 'ಲೈವ್ ಮಾನಿಟರ್',
  'dash.noDisruption': 'ಯಾವುದೇ ಡೇಟಾ ಇಲ್ಲ.',
  'dash.simulateTitle': 'ಸಿಮ್ಯುಲೇಟ್ ಮಾಡಿ',
  'dash.simulateDesc': 'ಆಟೋಮೆಟೆಡ್ ಕ್ಲೈಮ್ ರನ್ ಮಾಡಿ.',
  'dash.simulateBtn': 'ಮಳೆ ಸಿಮ್ಯುಲೇಟ್ ಮಾಡಿ',
  'dash.processing': 'ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ...',
  'dash.noClaims': 'ಕ್ಲೈಮ್ಸ್ ಇಲ್ಲ.',
  'dash.viewAll': 'ಎಲ್ಲವನ್ನೂ ವೀಕ್ಷಿಸಿ →',
  'dash.workSchedule': 'ಕೆಲಸದ ವೇಳಾಪಟ್ಟಿ',
  'dash.workingHours': 'ಕೆಲಸದ ಸಮಯ',
  'dash.partTime': 'ಅರೆಕಾಲಿಕ (4-6 ಗಂಟೆ/ದಿನ)',
  'dash.fullTime': 'ಪೂರ್ಣಕಾಲಿಕ (8-12 ಗಂಟೆ/ದಿನ)',
  'dash.extended': 'ವಿಸ್ತೃತ (12-16 ಗಂಟೆ/ದಿನ)',
  'dash.shiftStart': 'ಶಿಫ್ಟ್ ಪ್ರಾರಂಭ',
  'dash.shiftEnd': 'ಶಿಫ್ಟ್ ಅಂತ್ಯ',
  'dash.workingDays': 'ಕೆಲಸದ ದಿನಗಳು',
  'dash.saveSchedule': 'ವೇಳಾಪಟ್ಟಿ ಉಳಿಸಿ',
  'dash.saving': 'ಉಳಿಸುತ್ತಿದೆ...',
  'policy.title': 'ವಿಮೆ ಪಾಲಿಸಿ',
  'policy.subtitle': 'ಪ್ರತಿ ಸೋಮವಾರ ನವೀಕರಣ',
  'policy.active': 'ಸಕ್ರಿಯ',
  'policy.protected': 'ರಕ್ಷಿತ',
  'policy.expires': 'ಮುಕ್ತಾಯ',
  'policy.cancel': 'ಪಾಲಿಸಿ ರದ್ದುಮಾಡಿ',
  'policy.chooseTier': 'ಕವರೇಜ್ ಟೈರ್ ಆಯ್ಕೆ ಮಾಡಿ',
  'policy.premiumBreakdown': 'ಪ್ರೀಮಿಯಂ ವಿವರಗಳು',
  'policy.perWeek': 'ವಾರಕ್ಕೆ · UPI ಆಟೋಪೇ',
  'policy.maxPayout': 'ಗರಿಷ್ಠ ಮೊತ್ತ',
  'policy.baseRate': 'ಮೂಲ ದರ',
  'policy.zoneRisk': 'ವಲಯ ಅಪಾಯ',
  'policy.seasonMul': 'ಸೀಸನ್',
  'policy.claimsFreeDisc': 'ರಿಯಾಯಿತಿ',
  'policy.surgeLoading': 'ಸರ್ಜ್',
  'policy.tierMul': 'ಟೈರ್',
  'policy.weeklyPremium': 'ವಾರದ ಪ್ರೀಮಿಯಂ',
  'policy.activate': 'ಸಕ್ರಿಯಗೊಳಿಸಿ',
  'policy.activating': 'ಆಗುತ್ತಿದೆ...',
  'policy.history': 'ಪಾಲಿಸಿ ಇತಿಹಾಸ',
  'policy.popular': 'ಜನಪ್ರಿಯ',
  'tier.basic': 'ಮೂಲ',
  'tier.standard': 'ಸ್ಟ್ಯಾಂಡರ್ಡ್',
  'tier.premium': 'ಪ್ರೀಮಿಯಂ',
  'tier.basic.desc': 'ಅರೆಕಾಲಿಕ ಕಾರ್ಮಿಕರಿಗೆ',
  'tier.standard.desc': 'ಶಿಫಾರಸು ಮಾಡಲಾಗಿದೆ',
  'tier.premium.desc': 'ಗರಿಷ್ಠ ರಕ್ಷಣೆ',
  'claims.title': 'ಕ್ಲೈಮ್ಸ್',
  'claims.subtitle': 'ಆಟೋಮೆಟೆಡ್ ಪಾವತಿಗಳು',
  'claims.simulator': 'ಸಿಮ್ಯುಲೇಟರ್',
  'claims.fireTrigger': 'ಟ್ರಿಗರ್ ಮಾಡಿ →',
  'claims.processingPipeline': 'ಪೈಪ್ಲೈನ್...',
  'claims.processed': 'ಕ್ಲೈಮ್ ಪೂರ್ಣಗೊಂಡಿದೆ',
  'claims.predictedLoss': 'ನಷ್ಟದ ಅಂದಾಜು',
  'claims.actualEarned': 'ಆದಾಯ',
  'claims.netLoss': 'ನಿವ್ವಳ ನಷ್ಟ',
  'claims.coverage': 'ಕವರೇಜ್',
  'claims.payout': 'ಪಾವತಿ ಮೊತ್ತ',
  'claims.fraudScore': 'ಫ್ರಾಡ್ ಸ್ಕೋರ್',
  'claims.ppcs': 'PPCS',
  'claims.decision': 'ನಿರ್ಧಾರ',
  'claims.history': 'ಕ್ಲೈಮ್ಸ್ ಇತಿಹಾಸ',
  'claims.noClaims': 'ಯಾವುದೇ ಕ್ಲೈಮ್ ಇಲ್ಲ.',
  'onboard.getStarted': 'ಪ್ರಾರಂಭಿಸಿ',
  'onboard.enterPhone': 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ ನಮೂದಿಸಿ.',
  'onboard.mobile': 'ಮೊಬೈಲ್ ಸಂಖ್ಯೆ',
  'onboard.sendOtp': 'OTP ಕಳುಹಿಸಿ →',
  'onboard.sending': 'ಕಳುಹಿಸುತ್ತಿದೆ...',
  'onboard.terms': 'ನೀವು ನಿಯಮಗಳಿಗೆ ಸಮ್ಮತಿಸುತ್ತೀರಿ.',
  'onboard.verifyOtp': 'OTP ಪರಿಶೀಲಿಸಿ',
  'onboard.sentTo': 'ಕಲಿಸಲ್ಪಟ್ಟಿದೆ +91',
  'onboard.otpLabel': '6-ಅಂಕಿಯ OTP',
  'onboard.verifyBtn': 'OTP ಪರಿಶೀಲಿಸಿ →',
  'onboard.verifying': 'ಪರಿಶೀಲಿಸಲಾಗುತ್ತಿದೆ...',
  'onboard.backPhone': 'ಹಿಂದೆ',
  'onboard.profile': 'ನಿಮ್ಮ ಪ್ರೊಫೈಲ್',
  'onboard.profileDesc': 'ಮಾಹಿತಿ ನೀಡಿ.',
  'onboard.fullName': 'ಪೂರ್ಣ ಹೆಸರು',
  'onboard.aadhaar': 'ಆಧಾರ್ ಕೊನೆ 4 ಅಂಕೆ',
  'onboard.upiId': 'UPI ID',
  'onboard.platforms': 'ಪ್ಲಾಟ್ಫಾರ್ಮ್',
  'onboard.continue': 'ಮುಂದುವರಿಯಿರಿ →',
  'onboard.workArea': 'ನಿಮ್ಮ ಕಾರ್ಯಕ್ಷೇತ್ರ',
  'onboard.workAreaDesc': 'ರಿವಾರ್ಡ್ ಲೆಕ್ಕಾಚಾರ.',
  'onboard.city': 'ನಗರ',
  'onboard.selectCity': 'ನಗರ ಆಯ್ಕೆ ಮಾಡಿ',
  'onboard.zone': 'ವಲಯ',
  'onboard.selectZone': 'ವಲಯ ಆಯ್ಕೆ ಮಾಡಿ',
  'onboard.weeklyIncome': 'ವಾರದ ಆದಾಯ',
  'onboard.activateKavach': 'KAVACH ಸಕ್ರಿಯಗೊಳಿಸಿ →',
  'onboard.creatingAccount': 'ರಚಿಸಲಾಗುತ್ತಿದೆ...',
  'onboard.back': 'ಹಿಂದೆ',
  'onboard.fillRequired': 'ಎಲ್ಲಾ ಮಾಹಿತಿ ನೀಡಿ',
  'onboard.about': 'ಬಗ್ಗೆ',
  'onboard.howItWorks': 'ಕೆಲಸ ಮಾಡುವ ರೀತಿ',
  'onboard.faqs': 'FAQs',
  'onboard.whyKavach': 'ಏಕೆ KAVACH',
  'onboard.builtFor': 'ಭಾರತದ ಡೆಲಿವರಿ ಬಾಯ್ಸ್ ಗೆ',
  'onboard.howTitle': 'ಮುಖ್ಯ ಮಾಹಿತಿ',
  'onboard.faqTitle': 'ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು',
  'onboard.faqSubtitle': 'ಮಾಹಿತಿ',
  'hero.badge': "ಮೊದಲ AI ವಿಮೆ",
  'hero.title1': 'ನಿಮ್ಮ ಜೊತೆಗೂಡುವ',
  'hero.title2': 'ಪಾಲಿಸಿ',
  'hero.desc': 'AI ನಿಂದ ಕಾರ್ಯ ನಿರ್ವಹಣೆ.',
  'hero.stat1.value': '10,000+',
  'hero.stat1.label': 'ಪಾಲುದಾರರು',
  'hero.stat2.label': 'ಕ್ಲೈಮ್ಸ್',
  'hero.stat3.value': '<60s',
  'hero.stat3.label': 'ಪಾವತಿ',
  'hero.stat4.value': '16 ನಗರಗಳು',
  'hero.stat4.label': 'ನೆಟ್ವರ್ಕ್',
  'hero.testimonial': "'ಉತ್ತಮ ಪಾಲಿಸಿ.'",
  'hero.testimonialSub': 'ವೇಗದ ಪಾವತಿ.',
  'feature.weather.title': 'ಹವಾಮಾನ ರಕ್ಷಣೆ',
  'feature.weather.desc': 'ಸ್ವಯಂ ಪಾವತಿ',
  'feature.instant.title': 'ತ್ವರಿತ ಪಾವತಿ',
  'feature.instant.desc': '60 ಸೆಕೆಂಡ್ ನಲ್ಲಿ',
  'feature.upi.title': 'UPI ಪಾವತಿ',
  'feature.upi.desc': 'ನೇರ ಪಾವತಿ',
  'feature.weekly.title': 'ವಾರದ ಪ್ಲಾನ್',
  'feature.weekly.desc': 'ಉತ್ತಮ ಯೋಜನ',
  'step.register': 'ನೋಂದಣಿ',
  'step.register.desc': 'ಮೊಬೈಲ್ ಮೂಲಕ',
  'step.plan': 'ಆಯ್ಕೆ ಮಾಡಿ',
  'step.plan.desc': 'ಟ್ರೇಡ್ ಆಯ್ಕೆ',
  'step.protected': 'ರಕ್ಷಣೆ',
  'step.protected.desc': 'AI ರಕ್ಷಣೆ',
  'step.paid': 'ಪಾವತಿ',
  'step.paid.desc': 'ಖಾತೆಗೆ ನೇರ',
  'faq.q1': 'KAVACH ಏನು?',
  'faq.a1': 'ಉತ್ತಮ ವಿಮೆ.',
  'faq.q2': 'ಹಣ ಹೇಗೆ ಬರುತ್ತೆ?',
  'faq.a2': 'UPI ಮೂಲಕ.',
  'faq.q3': 'ಪ್ಲಾನ್ ಗಳು?',
  'faq.a3': 'ಮೂರು ವಿಧ.',
  'faq.q4': 'AI ಕೆಲಸ?',
  'faq.a4': 'ಅತ್ಯುತ್ತಮ ಕೆಲಸ.',
  'faq.q5': 'ರದ್ದು ಮಾಡಬಹುದೇ?',
  'faq.a5': 'ಹೌದು.',
  'faq.q6': 'ನಗರಗಳು?',
  'faq.a6': '16 ನಗರಗಳಲ್ಲಿ.',
  'footer.tagline': 'ನಿಮ್ಮ ವಿಮೆ',
  'footer.privacy': 'ಗೌಪ್ಯತೆ',
  'footer.terms': 'ನಿಯಮಗಳು',
  'footer.contact': 'ಸಂಪರ್ಕಿಸಿ',
  'footer.copyright': '© 2026 KAVACH.',
  'onboard.shiftStart': 'ಶಿಫ್ಟ್ ಆರಂಭ',
  'onboard.shiftEnd': 'ಶಿಫ್ಟ್ ಅಂತ್ಯ',
  'onboard.workingDays': 'ಕೆಲಸದ ದಿನ',
  'onboard.workingHours': 'ಸಮಯ',
  'onboard.partTime': 'ಅರೆಕಾಲಿಕ',
  'onboard.fullTime': 'ಪೂರ್ಣಕಾಲಿಕ',
  'onboard.extended': 'ವಿಸ್ತೃತ',
  'onboard.devOtp': 'Dev OTP',
};

const ml = {
  ...en,
  'app.tagline': 'ഡെലിവറി പങ്കാളികൾക്കുള്ള വരുമാന സംരക്ഷണം',
  'common.loading': 'ലോഡ് ചെയ്യുന്നു...',
  'common.logout': 'ലോഗ്ഔട്ട്',
  'nav.dashboard': 'ഹോം',
  'nav.policy': 'പോളിസി',
  'nav.claims': 'ക്ലെയിംസ്',
  'nav.admin': 'അഡ്മിൻ',
  'dash.greeting.morning': 'സുപ്രഭാതം',
  'dash.greeting.afternoon': 'ശുഭ ഉച്ച',
  'dash.greeting.evening': 'ശുഭ സന്ധ്യ',
  'dash.weeklyCoverage': 'പ്രതിവാര കവറേജ്',
  'dash.noActivePolicy': 'സജീവ പോളിസി ഇല്ല',
  'dash.activatePolicy': 'പോളിസി സജീവമാക്കുക →',
  'dash.weeklyPremium': 'പ്രതിവാര പ്രീമിയം',
  'dash.recentClaims': 'സമീപകാല ക്ലെയിംസ്',
  'dash.claimsFree': 'ക്ലെയിം ഇല്ലാത്ത',
  'dash.liveMonitor': 'ലൈവ് മോണിറ്റർ',
  'dash.noDisruption': 'തടസ്സങ്ങൾ ഒന്നുമില്ല.',
  'dash.simulateTitle': 'സിമുലേറ്റ് ചെയ്യുക',
  'dash.simulateDesc': 'ഓട്ടോമേറ്റഡ് ക്ലെയിം പരിശോധിക്കുക.',
  'dash.simulateBtn': 'മഴ ക്ലെയിം സിമുലേറ്റ് ചെയ്യുക',
  'dash.processing': 'പ്രോസസിംഗ്...',
  'dash.noClaims': 'ക്ലെയിമുകൾ ഒന്നുമില്ല.',
  'dash.viewAll': 'എല്ലാം കാണുക →',
  'dash.workSchedule': 'ജോലി ഷെഡ്യൂൾ',
  'dash.workingHours': 'ജോലി സമയം',
  'dash.partTime': 'പാർട്ട്-ടൈം (4-6 മണിക്കൂർ)',
  'dash.fullTime': 'ഫുൾ-ടൈം (8-12 മണിക്കൂർ)',
  'dash.extended': 'കൂടുതൽ സമയം (12-16 മണിക്കൂർ)',
  'dash.shiftStart': 'ഷിഫ്റ്റ് ആരംഭം',
  'dash.shiftEnd': 'ഷിഫ്റ്റ് അവസാനം',
  'dash.workingDays': 'ജോലി ദിവസങ്ങൾ',
  'dash.saveSchedule': 'ഷെഡ്യൂൾ സേവ് ചെയ്യുക',
  'dash.saving': 'സേവ് ചെയ്യുന്നു...',
  'policy.title': 'ഇൻഷുറൻസ് പോളിസി',
  'policy.subtitle': 'എല്ലാ തിങ്കളാഴ്ചയും പുതുക്കുന്ന പ്രതിവാര വരുമാന സംരക്ഷണം',
  'policy.active': 'സജീവം',
  'policy.protected': 'സംരക്ഷിതം',
  'policy.expires': 'കാലാവധി',
  'policy.cancel': 'പോളിസി റദ്ദാക്കുക',
  'policy.chooseTier': 'കവറേജ് ടയർ തിരഞ്ഞെടുക്കുക',
  'policy.premiumBreakdown': 'പ്രീമിയം വിശദാംശങ്ങൾ',
  'policy.perWeek': 'ആഴ്ചയിൽ · UPI ഓട്ടോ പേ',
  'policy.maxPayout': 'പരമാവധി തുക',
  'policy.baseRate': 'അടിസ്ഥാന നിരക്ക്',
  'policy.zoneRisk': 'സോൺ റിസ്ക്',
  'policy.seasonMul': 'സീസൺ',
  'policy.claimsFreeDisc': 'ഡിസ്കൗണ്ട്',
  'policy.surgeLoading': 'സർജ്',
  'policy.tierMul': 'ടയർ',
  'policy.weeklyPremium': 'പ്രതിവാര പ്രീമിയം',
  'policy.activate': 'സജീവമാക്കുക',
  'policy.activating': 'സജീവമാക്കുന്നു...',
  'policy.history': 'പോളിസി ചരിത്രം',
  'policy.popular': 'ജനപ്രിയമായത്',
  'tier.basic': 'ബേസിക്',
  'tier.standard': 'സ്റ്റാൻഡേർഡ്',
  'tier.premium': 'പ്രീമിയം',
  'tier.basic.desc': 'പാർട്ട്-ടൈം ജോലിക്കാർക്ക്',
  'tier.standard.desc': 'ശുപാർശ ചെയ്യുന്നത്',
  'tier.premium.desc': 'പരമാവധി സംരക്ഷണം',
  'claims.title': 'ക്ലെയിംസ്',
  'claims.subtitle': 'ഓട്ടോമേറ്റഡ് പേഔട്ടുകൾ',
  'claims.simulator': 'സിമുലേറ്റർ',
  'claims.fireTrigger': 'ട്രിഗർ ചെയ്യുക →',
  'claims.processingPipeline': 'പ്രോസസിംഗ്...',
  'claims.processed': 'ക്ലെയിം അംഗീകരിച്ചു',
  'claims.predictedLoss': 'നഷ്ടം',
  'claims.actualEarned': 'വരുമാനം',
  'claims.netLoss': 'യഥാർത്ഥ നഷ്ടം',
  'claims.coverage': 'കവറേജ്',
  'claims.payout': 'പേഔട്ട്',
  'claims.fraudScore': 'ഫ്രോഡ് സ്കോർ',
  'claims.ppcs': 'PPCS',
  'claims.decision': 'തീരുമാനം',
  'claims.history': 'ക്ലെയിംസ് ചരിത്രം',
  'claims.noClaims': 'ക്ലെയിമുകൾ ഇല്ല.',
  'onboard.getStarted': 'ആരംഭിക്കുക',
  'onboard.enterPhone': 'മൊബൈൽ നമ്പർ നൽകുക.',
  'onboard.mobile': 'മൊബൈൽ നമ്പർ',
  'onboard.sendOtp': 'OTP അയയ്ക്കുക →',
  'onboard.sending': 'അയയ്ക്കുന്നു...',
  'onboard.terms': 'നിങ്ങൾ നിബന്ധനകൾ അംഗീകരിക്കുന്നു.',
  'onboard.verifyOtp': 'OTP പരിശോധിക്കുക',
  'onboard.sentTo': 'അയച്ചത് +91',
  'onboard.otpLabel': '6-അക്ക OTP',
  'onboard.verifyBtn': 'OTP പരിശോധിക്കുക →',
  'onboard.verifying': 'പരിശോധിക്കുന്നു...',
  'onboard.backPhone': 'പിറകോട്ടു പോകുക',
  'onboard.profile': 'നിങ്ങളുടെ പ്രൊഫൈൽ',
  'onboard.profileDesc': 'വിവരങ്ങൾ നൽകുക.',
  'onboard.fullName': 'പൂർണ്ണ പേര്',
  'onboard.aadhaar': 'ആധാർ അവസാന 4 അക്കങ്ങൾ',
  'onboard.upiId': 'UPI ID',
  'onboard.platforms': 'പ്ലാറ്റ്‌ഫോമുകൾ',
  'onboard.continue': 'തുടരുക →',
  'onboard.workArea': 'നിങ്ങളുടെ ജോലിസ്ഥലം',
  'onboard.workAreaDesc': 'സോൺ തിരഞ്ഞെടുക്കുക.',
  'onboard.city': 'നഗരം',
  'onboard.selectCity': 'നഗരം തിരഞ്ഞെടുക്കുക',
  'onboard.zone': 'സോൺ',
  'onboard.selectZone': 'സോൺ തിരഞ്ഞെടുക്കുക',
  'onboard.weeklyIncome': 'പ്രതിവാര വരുമാനം',
  'onboard.activateKavach': 'KAVACH സജീവമാക്കുക →',
  'onboard.creatingAccount': 'അക്കൗണ്ട് നിർമ്മിക്കുന്നു...',
  'onboard.back': 'ബാക്ക്',
  'onboard.fillRequired': 'എല്ലാ വിവരങ്ങളും നൽകുക',
  'onboard.about': 'കുറിച്ച്',
  'onboard.howItWorks': 'എങ്ങനെ പ്രവർത്തിക്കുന്നു',
  'onboard.faqs': 'FAQs',
  'onboard.whyKavach': 'എന്തുകൊണ്ട് KAVACH',
  'onboard.builtFor': 'ഇന്ത്യയിലെ ഡെലിവറി വർക്കർമാർക്ക്',
  'onboard.howTitle': 'മുഖ്യ വിവരങ്ങൾ',
  'onboard.faqTitle': 'പതിവ് ചോദ്യങ്ങൾ',
  'onboard.faqSubtitle': 'വിവരങ്ങൾ',
  'hero.badge': "ആദ്യത്തെ AI ഇൻഷുറൻസ്",
  'hero.title1': 'നിങ്ങളുടെ കൂടെ',
  'hero.title2': 'പോളിസി',
  'hero.desc': 'AI വഴി പ്രവർത്തിക്കുന്നു.',
  'hero.stat1.value': '10,000+',
  'hero.stat1.label': 'പങ്കാളികൾ',
  'hero.stat2.label': 'ക്ലെയിംസ്',
  'hero.stat3.value': '<60s',
  'hero.stat3.label': 'പേഔട്ട്',
  'hero.stat4.value': '16 നഗരങ്ങൾ',
  'hero.stat4.label': 'നെറ്റ്‌വർക്ക്',
  'hero.testimonial': "'മികച്ച പോളിസി.'",
  'hero.testimonialSub': 'വേഗത്തിലുള്ള പേഔട്ട്.',
  'feature.weather.title': 'കാലാവസ്ഥ സംരക്ഷണം',
  'feature.weather.desc': 'ഓട്ടോ പേഔട്ട്',
  'feature.instant.title': 'ഉടൻ പേഔട്ട്',
  'feature.instant.desc': '60 സെക്കന്റിൽ',
  'feature.upi.title': 'UPI പേഔട്ട്',
  'feature.upi.desc': 'നേരിട്ട് അക്കൗണ്ടിൽ',
  'feature.weekly.title': 'പ്രതിവാര പ്ലാൻ',
  'feature.weekly.desc': 'മികച്ച പ്ലാൻ',
  'step.register': 'രജിസ്റ്റർ ചെയ്യുക',
  'step.register.desc': 'മൊബൈൽ വഴി',
  'step.plan': 'പ്ലാൻ തിരഞ്ഞെടുക്കുക',
  'step.plan.desc': 'ടയർ തിരഞ്ഞെടുക്കുക',
  'step.protected': 'സംരക്ഷണം',
  'step.protected.desc': 'AI സംരക്ഷിക്കുന്നു',
  'step.paid': 'പേഔട്ട്',
  'step.paid.desc': 'നേരിട്ട് അക്കൗണ്ടിൽ',
  'faq.q1': 'KAVACH എന്താണ്?',
  'faq.a1': 'മികച്ച ഇൻഷുറൻസ്.',
  'faq.q2': 'പണം എങ്ങനെ കിട്ടും?',
  'faq.a2': 'UPI വഴി.',
  'faq.q3': 'പ്ലാനുകൾ?',
  'faq.a3': 'മൂന്നുതരം.',
  'faq.q4': 'AI പ്രവർത്തനം?',
  'faq.a4': 'മികച്ചത്.',
  'faq.q5': 'റദ്ദാക്കാമോ?',
  'faq.a5': 'അതെ.',
  'faq.q6': 'നഗരങ്ങൾ?',
  'faq.a6': '16 നഗരങ്ങൾ.',
  'footer.tagline': 'നിങ്ങളുടെ ഇൻഷുറൻസ്',
  'footer.privacy': 'സ്വകാര്യത',
  'footer.terms': 'നിബന്ധനകൾ',
  'footer.contact': 'ബന്ധപ്പെടുക',
  'footer.copyright': '© 2026 KAVACH.',
  'onboard.shiftStart': 'ഷിഫ്റ്റ് ആരംഭം',
  'onboard.shiftEnd': 'ഷിഫ്റ്റ് അവസാനം',
  'onboard.workingDays': 'ദിവസങ്ങൾ',
  'onboard.workingHours': 'സമയം',
  'onboard.partTime': 'പാർട്ട്-ടൈം',
  'onboard.fullTime': 'ഫുൾ-ടൈം',
  'onboard.extended': 'കൂടുതൽ സമയം',
  'onboard.devOtp': 'Dev OTP',
};

export const translations = { en, hi, bn, te, mr, ta, kn, ml };
